import { render, staticRenderFns } from "./NotificationUser.vue?vue&type=template&id=376bd52b&scoped=true"
import script from "./NotificationUser.vue?vue&type=script&lang=js"
export * from "./NotificationUser.vue?vue&type=script&lang=js"
import style0 from "./NotificationUser.vue?vue&type=style&index=0&id=376bd52b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bd52b",
  null
  
)

export default component.exports